import hyRequest from '@/service';
import { IBeltScaleData, IBeltScaleDataParams } from './type';

enum DashboardApi {
  getBeltScaleData = '/product/getBeltWeigherList'
}

// 获取皮带秤数据
export function getBeltScaleData(data: IBeltScaleDataParams) {
  return hyRequest.get<IBeltScaleData>({
    url: DashboardApi.getBeltScaleData,
    params: {
      ...data
    }
  });
}
